/* RESPONSIBLE TEAM: team-frontend-tech */
import relativeTime from 'embercom/lib/relative-time';

let fullRelativeTimeAgo = function (dateString) {
  return relativeTime(dateString, 'en-full-relative-time-ago');
};

export default fullRelativeTimeAgo;
